import { EXTENSION_FETCH_SUCCESS, type ExtensionFetchAction } from '../../../actions/extension';
import type { ExtensionConfigStateType } from './types';

const initialState = {
	operations: [],
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (
	state: ExtensionConfigStateType = initialState,
	action: ExtensionFetchAction,
): ExtensionConfigStateType => {
	if (action.type === EXTENSION_FETCH_SUCCESS) {
		return action.payload.extension;
	}
	return state;
};
